export default "__VITE_ASSET__u3hPJ7eF__"